import React from "react";

import Job from "./job";

const Jobs = ({ tasks }) => {
    return (
        <div>
            {tasks.map((task) => (
                <Job key={task.FK_workOrderNumber} data={task} />
            ))}
        </div>
    );
};

export default Jobs;
